import axios from '@/request';
import qs from 'qs';

export default {
    async list(params: any) {
        return axios.get('dmarketing/list', { params });
    },
    async add(params: any) {
        return axios.post('dmarketing/add', qs.stringify(params))
    },
    async rushHour(params: any) {
        return axios.get('dmarketing/time-setting', { params })
    },
    async getRushHour(params: any) {
        return axios.get('dmarketing/get-time-setting', { params })
    },
    async addRushHour(params: any) {
        return axios.post('dmarketing/add-time-setting', qs.stringify(params))
    },
    async editRushHour(params: any) {
        return axios.post('dmarketing/edit-time-setting', qs.stringify(params))
    },
    async deleteRushHour(params: any) {
        return axios.post('dmarketing/delete-time-setting', qs.stringify(params))
    }
}
